import _getOr from 'lodash/fp/getOr'
import moment from 'moment'
import { titleEkyc } from '../../domain/data-model/constants'
import { isSelectedRemoteSelling } from 'quick-quote/selectors'
import {
  getRemoteSellingState,
  havePayer,
  isForeigner,
  isNeedConfirmationLetterSelector,
} from 'e-submission/domain/data-model/form/selectors'
import _ from 'lodash'

function getSendingMethodDetail(
  remoteSellingState,
  sendLinkEkycDetail,
  isReuse,
  insuredOrPayer,
  selectedRemoteSelling,
  isNeedConfirmationLetter
) {
  let method = _getOr('', ['method'], sendLinkEkycDetail)
  let textInput = _getOr('', ['textInput'], sendLinkEkycDetail)
  let notifyType = isReuse
    ? selectedRemoteSelling && isNeedConfirmationLetter
      ? { notifyType: method }
      : { notifyType: 'none' }
    : { notifyType: method }

  return {
    method,
    textInput,
    notifyType,
  }
}

function getTextInput(decision, textInput) {
  if (decision) return textInput
  return ''
}

export const mappingCaseKeeper = (app, insuredOrPayer, isReuse = false, remoteSelling = false, verificationId = '') => {
  const insuredInfo = _getOr({}, ['quickQuote', 'insured'], app)
  const payerInfo = _getOr({}, ['quickQuote', 'insured', 'payer'], app)
  const sendLinkEkycDetail = _getOr({}, ['ekycInfo', 'sendLink'], app)
  const title = _getOr('other', [insuredOrPayer, 'title', 'value'], app)
  const foreigner = isForeigner(app, insuredOrPayer)
  const hasPayer = havePayer(app)
  const isNeedConfirmationLetter = isNeedConfirmationLetterSelector(insuredOrPayer, app)
  const selectedRemoteSelling = _.get(app, ['selectedRemoteSelling'], false)
  const reusedResults = []

  const mapPersonalInfo = {
    insured: { ...insuredInfo, esub: _getOr({}, ['insured'], app) },
    payer: { ...payerInfo, esub: _getOr({}, ['payer'], app) },
  }
  let defaultProcessConfig = {
    required: true,
    attempts: 3,
    dependenciesRequired: false,
    livenessCount: 1,
  }

  const remoteSellingState = getRemoteSellingState(app)
  const { method, textInput, notifyType } = getSendingMethodDetail(
    remoteSellingState,
    sendLinkEkycDetail,
    isReuse,
    insuredOrPayer,
    selectedRemoteSelling,
    isNeedConfirmationLetter
  )
  const insuredMobileNumber = _getOr('', 'insured.mobileNumber', app)

  const proprietorsObject = {
    firstName: _getOr('', [insuredOrPayer, 'esub', 'firstName'], mapPersonalInfo),
    lastName: _getOr('', [insuredOrPayer, 'esub', 'lastName'], mapPersonalInfo),
    proprietorType: insuredOrPayer,
    ...notifyType,
    countryCode: 'TH',
    citizenId: _getOr('', [insuredOrPayer, 'esub', 'idNo', 'citizenId'], mapPersonalInfo),
    passportNumber: _getOr('', [insuredOrPayer, 'esub', 'idNo', 'passport'], mapPersonalInfo),
    phoneNumber: method === 'email' ? insuredMobileNumber : getTextInput(method === 'sms', textInput),
    email: getTextInput(method === 'email', textInput),
    title: titleEkyc[title],

    frontIdCardConfig: {
      ...defaultProcessConfig,
      threshHold: 0.8,
      isEditable: true,
    },
    backIdCardConfig: {
      ...defaultProcessConfig,
      threshHold: 0.95,
      isEditable: true,
    },
    dopaConfig: {
      required: true,
      attempts: 3,
      livenessCount: 1,
      threshHold: 1.0,
      isEditable: false,
      dependenciesRequired: true,
    },
    expiryDuration: 'P3D',
    expiresAt: moment()
      .add(30, 'days')
      .format(),
  }
  if (remoteSelling) {
    const insurancePolicyAgreementConfig = {
      content: [
        {
          key: 'title',
          value: 'กรุณาอ่านเพื่อทำความเข้าใจและยืนยันข้อมูล',
        },
        {
          key: 'content',
          value: `ข้าพเจ้า ${
            foreigner ? proprietorsObject.title.translations.en.label : proprietorsObject.title.translations.th.label
          } ${proprietorsObject.firstName} ${
            proprietorsObject.lastName
          } ขอยืนยันแสดงความประสงค์ในการทำประกันภัยกับ บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) โดยการเสนอขายโดยวิธีการสื่อสารผ่านอุปกรณ์อิเล็กทรอนิกส์ โดยใช้เสียง หรือเสียงและภาพ และข้าพเจ้ามีความประสงค์ให้ตัวแทนประกันชีวิตทำการเสนอขายกรมธรรม์ประกันชีวิตโดยวิธีดังกล่าว ดังนั้นข้าพเจ้าจึงขอแสดงความประสงค์ผ่านระบบนี้`,
        },
        {
          key: 'checkBoxLabel',
          value:
            'ทั้งนี้ ข้าพเจ้าขอยืนยันว่าข้าพเจ้าได้ศึกษาทำความเข้าใจ เงื่อนไขความคุ้มครอง ข้อยกเว้นของกรมธรรม์ฉบับนี้แล้ว และขอยืนยันความประสงค์ในการสมัครทำกรมธรรม์ประกันภัยฉบับนี้',
        },
        {
          key: 'submitButtonTitle',
          value: 'ยืนยันข้อมูล',
        },
      ],
      required: true,
      attempts: 3,
      livenessCount: 1,
    }

    const passportConfig = {
      required: true,
      attempts: 3,
      dependenciesRequired: true,
      livenessCount: 1,
      threshHold: 0.8,
      isEditable: true,
    }

    const idFaceRecognitionConfig = {
      required: true,
      attempts: 3,
      dependenciesRequired: false,
      livenessCount: 1,
      threshHold: 0.9,
    }

    const verificationsObject = [
      {
        verificationId,
        notifyType: notifyType?.notifyType,
        phoneNumber: method === 'email' ? insuredMobileNumber : getTextInput(method === 'sms', textInput),
        email: getTextInput(method === 'email', textInput),
        insurancePolicyAgreementConfig: isNeedConfirmationLetter ? insurancePolicyAgreementConfig : {},
      },
    ]

    Object.assign(proprietorsObject, {
      idFaceRecognitionConfig,
      insurancePolicyAgreementConfig: isNeedConfirmationLetter ? insurancePolicyAgreementConfig : {},
    })

    if (foreigner) {
      reusedResults.push('passport', 'idFaceRecognition')
      Object.assign(verificationsObject[0], {
        passportConfig,
        idFaceRecognitionConfig,
      })
      Object.assign(proprietorsObject, {
        frontIdCardConfig: {},
        backIdCardConfig: {},
        dopaConfig: {},
      })
      Object.assign(proprietorsObject, {
        passportConfig,
        idFaceRecognitionConfig,
        insurancePolicyAgreementConfig: isNeedConfirmationLetter ? insurancePolicyAgreementConfig : {},
      })
    } else {
      Object.assign(verificationsObject[0], {
        frontIdCardConfig: {
          ...defaultProcessConfig,
          threshHold: 0.8,
          isEditable: true,
        },
        backIdCardConfig: {
          ...defaultProcessConfig,
          threshHold: 0.95,
          isEditable: true,
        },
        dopaConfig: {
          required: true,
          attempts: 3,
          livenessCount: 1,
          threshHold: 1.0,
          isEditable: false,
          dependenciesRequired: true,
        },
        idFaceRecognitionConfig,
      })
      reusedResults.push('frontIdCard', 'backIdCard', 'dopa', 'idFaceRecognition')
    }

    if (isReuse && isNeedConfirmationLetter) {
      delete proprietorsObject.frontIdCardConfig
      delete proprietorsObject.backIdCardConfig
      delete proprietorsObject.dopaConfig
      delete proprietorsObject.idFaceRecognitionConfig
      delete proprietorsObject.passportConfig
      delete proprietorsObject.insurancePolicyAgreementConfig

      Object.assign(verificationsObject[0], {
        reusedResults,
      })
      Object.assign(proprietorsObject, {
        verifications: verificationsObject,
      })
    }
  }

  const caseKeeperObject = {
    caseType: {
      key: 'default',
      code: '000',
      translations: {
        en: {
          label: 'Default',
        },
        th: {
          label: 'Default',
        },
        id: {
          label: 'Default',
        },
      },
    },
    proprietors: [proprietorsObject],
    remark: '',
    attachMeetingRoom: false,
    appNumber: '',
    policies: [
      {
        policyNumber: '',
      },
    ],
    department: '/new-business',
  }
  return caseKeeperObject
}

export const resendCasePayload = (app, currentProprietorId) => {
  const sendLinkEkycDetail = _getOr({}, ['ekycInfo', 'sendLink'], app)
  const method = _getOr('', ['method'], sendLinkEkycDetail)
  const data = _getOr('', ['textInput'], sendLinkEkycDetail)

  return {
    proprietorId: currentProprietorId,
    data: {
      method,
      email: method === 'email' ? data : '',
      sms: method === 'sms' ? data : '',
    },
    type: 'notification',
  }
}

export const replaceSendingDetailForResendRemoteSellingCasePayload = (remoteSelling, payload) => {
  try {
    if (!remoteSelling) {
      return {}
    }
    const { sendingMethod, email, sms } = remoteSelling

    return {
      ...payload,
      type: 'invite',
      data: {
        method: sendingMethod,
        email: sendingMethod === 'email' ? email : '',
        sms: sendingMethod === 'sms' ? sms : '',
      },
    }
  } catch (e) {
    console.error(``)
  }
}

export const setAttachmentPayload = (insuredOrPayer, app, url, name, type = 'image/jpeg') => {
  const attachmentId =
    name === 'id-card' || name === 'passport' || name === 'face-recognition' || name === 'face-image'
      ? insuredOrPayer === 'insured'
        ? `insured-${name}`
        : `owner-${name}`
      : `${insuredOrPayer}-${name}`
  const applicationId = _getOr('', 'applicationId', app)

  return {
    attachmentId,
    applicationId,
    url,
    type,
  }
}
